import { FC, useMemo } from 'react'

import { FlexDirectionBreak } from 'core-components/sitebuilder/models/flexGrid/FlexDirectionBreak'
import { MeasureController } from 'core/analytics'

import { Modal } from './components/modal/Modal'
import { WizardContent } from './components/wizardContent/WizardContent'

import styles from './PlanningWizard.module.scss'

interface IPlanningWizardProps {
  pid: string
  isOpen: boolean
  onClose: () => void

  widgetParams: IObjectAny
  flexWidth: FlexDirectionBreak
  metrics: MeasureController
}

export const PlanningWizard: FC<IPlanningWizardProps> = ({
  pid,
  isOpen,
  onClose,
  widgetParams,
  flexWidth,
  metrics,
}) => {
  /** ------------------------- Variables ------------------------- */

  const modalClasses = useMemo(
    () => ({
      overlay: styles.hideCrossIcon,
      body: styles.modalContent,
    }),
    []
  )

  const contentProps = useMemo(
    () => ({
      onClose,
      widgetParams,
      flexWidth,
      metrics,
      pid,
    }),
    [onClose, widgetParams, flexWidth, metrics, pid]
  )

  /** ------------------------- Render ------------------------- */

  if (!isOpen) {
    return null
  }

  return (
    <Modal
      show={true}
      onClose={onClose}
      classes={modalClasses}
      size="xl"
      closeOnOutsideClick={false}
      content={WizardContent}
      contentProps={contentProps}
    />
  )
}
